import { createGlobalStyle } from 'styled-components';
import buttons from './buttons';
import { colorSchema } from '@ontruck/orc';
import { themeBaseOverwrite } from 'utils/style';
import { normalize } from 'styled-normalize';
import { getTenantPreLoginConfig } from '../tenant/teanantPreLoginConfig';
import { ThemeProvider } from '@ontruck/fe-themes';

function convertColorKeysToCSSVariables(colorsObject) {
  const colors = Object.entries(colorsObject);

  return colors.reduce((acc, current) => {
    const [key, value] = current;

    return [...acc, `--${key}: ${value};`];
  }, []);
}

const GenericGlobalStyles = createGlobalStyle`
  ${normalize}

  *{
    box-sizing: border-box;
  }

  button, input, optgroup, select, textarea{
    font-family: 'Roboto', Verdana, sans-serif;
  }

  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    -webkit-tap-highlight-color: transparent;
    font-size: 62.5%;
    height: 100%;
  }

  body {
    font-family: 'Roboto', Verdana, sans-serif;
    font-size: ${({ textBase = '1.2rem' }) => textBase};
    -webkit-font-smoothing: antialiased;
    transform: scale(1);
    line-height: 1.5;
    margin: 0;
    padding: 0;
    height: 100%;
    color: ${({ fontColor = colorSchema.blackBat }) => fontColor};
  }

	:root {
		${convertColorKeysToCSSVariables(colorSchema)}
		${convertColorKeysToCSSVariables(themeBaseOverwrite.colorSchema)}
    --deep-purple900: #9A11B3;
    --deep-purple500: #9a11b3;
    --deep-purple100: #fae0ff;
    --success100: #e9ffd6;
    --success300: #c9fe9a;
    --success900: #397A00;
    --error-100: #ffe0e2;
    --error-300: #fdafb3;
    --error-500: #fc737a;
    --error-700: #fc030f;
    --error-900: #cc000a;
    --primary50: #F0F5FF;
    --primary-top-bar: #0140CD;
    --primary-filters: #013198;
    --primary-top-bar-color: #fff;
    --primary-top-bar-border: #013198;
    --button-primary-bg: #01309a;
    --login-logo-width: 122px;
    --primary-background: #fff;
    --accent-color-blue: #0140CD;
	}
  ${buttons}
`;

const tenantThemeName = getTenantPreLoginConfig().styles;

const GlobalStyles = () => {
  return (
    <>
      <GenericGlobalStyles />
      <ThemeProvider theme={tenantThemeName} /> {/* tenant theme custom variables provider */}
    </>
  );
};

export default GlobalStyles;
